export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Umstrittene Säulen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurücksetzen"])}
}